module.exports = __webpack_public_path__ + "img/logo.93c76822.png";